export enum CustompageImageType{
    GALLERY = "GALLERY",
    SINGLE_IMAGE = "SINGLE_IMAGE"
}

export enum CustompageTemplate{
    CLEAN = "CLEAN", 
    MAP = "MAP"
}

export enum CustomPageStatus{
    CANCELLED = "CANCELLED", 
    COMPLETED = "COMPLETED", 
    CONFIRMED = "CONFIRMED", 
    PENDING = "PENDING"
}
//Create, update
export class CustompageRequest{
    enableByCategoryNewsAndInsights: boolean;
    footerContent: string;
    galleryId: number;
    imageType: CustompageImageType
    mainContent: string;
    menuLabel: string;
    removeFooter: boolean
    enableListStoreOnMap: boolean;
    seoDescription: string;
    seoId: string;
    seoTitle: string;
    singleImageId: number;
    template: CustompageTemplate;
    published: boolean;
    title:  string;
    seoNoindex: boolean;
    newsInsightsTitle: string;
    newsInsightsAbstract: string;
    newsFilters: [];
    store: [];
    productServices: any[];
    promotionEvents: any[];
    dealerMap: any[];
    activityMap: any[];
    shoppingMalls: any[];
    breadcrumb: string;
    legalNote: string;
    
}

export class CustompageRequestSearch{
    createdAt: string;
    pageNumber: number;
    pageSize: number;
    createdBy: string;
    id: number;
    published: boolean;
    removeFooter: boolean;
    seoId: number;
    seoIdLike: number;
    title: string;
    sortBy:string;
    
}

//addActivityMap, addDealerMap, addNewsFilter, addProductService, addPromotionevent, addShoppingMall, addStore, 
//removeActivityMap, removeDealerMap, removeNewsFilter, removeProductService, removePromotionEvent, removeShoppingMall, removeStore
export class CustompageRequestAdd{
    idsList: number[];
}